import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Core2Config} from '../shared/core2Config';
import {bl_applet_catalog_hdr_RowInterface} from '../../../../../models/dbschema';

@Injectable({providedIn: 'root'})
export class CatalogHeaderService extends BaseApiTemplateService<{ bl_applet_catalog_hdr: bl_applet_catalog_hdr_RowInterface }> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.PLATFORM_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'catalog-headers';
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'catalog-headers';
    this.httpClient = http;
  }
}
